import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class EventsService {
	public objectCrud: EventEmitter<any>;
	public idObjectDeleted: EventEmitter<number>;
	public logout: EventEmitter<boolean>;
    public accept: EventEmitter<boolean>;
    public auxiliarDataRet: EventEmitter<boolean>;
    public confirmExportPioneer: EventEmitter<boolean>;
    public confirmExportDOW: EventEmitter<boolean>;
    public confirmCompleteDay: EventEmitter<any>;

	constructor() {
		this.objectCrud = new EventEmitter<any>();
		this.idObjectDeleted = new EventEmitter<number>();
		this.logout = new EventEmitter<boolean>();
        this.accept = new EventEmitter<boolean>();
        this.auxiliarDataRet = new EventEmitter<boolean>();
        this.confirmExportPioneer = new EventEmitter<boolean>();
        this.confirmExportDOW = new EventEmitter<boolean>();
        this.confirmCompleteDay = new EventEmitter<any>();
	}

    public setObjectCrud(objectCrud:any){
        this.objectCrud.emit(objectCrud);
    }

    public setDeletedId(id:number){
    	this.idObjectDeleted.emit(id);
    }

    public logoutEvent(logout){
    	this.logout.emit(logout);
    }

    public toAccept(accept:boolean){
        this.accept.emit(accept);
    }

    public wasRetrieved(retrieve:boolean){
        this.auxiliarDataRet.emit(retrieve);
    }

    confirmExportPioneerEvnt(confirm: boolean) {
        console.log('expFileMadeDOW c1')
        this.confirmExportPioneer.emit(confirm);
    }

    confirmExportDOWEvnt(confirm: boolean) {
        console.log('expFileMadeDOW c2')
        this.confirmExportDOW.emit(confirm);
    }


    public confirmCompleteDayEvent(data:any){
        this.confirmCompleteDay.emit(data);
    }

}


// WEBPACK FOOTER //
// /app/src/app/theme/services/events/events.service.ts